import {environment} from '../environments/environment';

import {nativeApiScopes} from './native-api-scopes';

const configuredApiScopes = nativeApiScopes(environment.azureAdClientId);

export const protectedResources: Record<string, any> = {
    api: {
        endpoint: environment.aiBaseServerUrl,
        scopes: [...configuredApiScopes],
    },
    enrich: {
        endpoint: environment.enrichBaseServerUrl,
        scopes: [...configuredApiScopes],
    },
    auth: {
        endpoint: environment.authBaseServerUrl,
        scopes: [...configuredApiScopes],
    },
    connect: {
        endpoint: environment.connectBaseServerUrl,
        scopes: [...configuredApiScopes],
    },
    webinars: {
        endpoint: environment.webinarsServerUrl,
        scopes: [...configuredApiScopes],
    },
    translations: {
        endpoint: environment.translationsBaseServerUrl,
        scopes: [...configuredApiScopes],
    },
    graph: {
        endpoint: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['User.Read'],
    },
};

export const loginRequest = {
    scopes: [
        'openid',
        'profile',
        'email',
        'offline_access',
        ...configuredApiScopes,
    ],
};
